define('specific/filtermanager/models/FilterManagerModel', [

], function() {

    var FilterManagerModel = Backbone.Model.extend({
        defaults: {
            type: "filtermanagerview",
            viewId: "",
            loadingInProgress: false,
            filters: [],
            currentFilterId: [],
            isReady: false,
            allowMultipleSelect: false
        }
    });

    return FilterManagerModel;
});
